import { render, staticRenderFns } from "./Fin.vue?vue&type=template&id=2bcb9066"
import script from "./Fin.vue?vue&type=script&lang=js"
export * from "./Fin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports